import React, { useMemo, useRef, useState } from "react";
import { BsFiletypePdf } from "react-icons/bs";
import PortalModal from "../PortalModal";
import img from "../../Assets/Logos/profile3.jpg";
import { QRCodeCanvas } from "qrcode.react";
import logo from "../../Assets/Logos/ashok.png";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";
import axios from "axios";
import { useEffect } from "react";
import PanCardPdf from "../PanCardPdf";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function RcToMobile() {
  const [rcNo, setRcNo] = useState("");
  const [rcPrice, setRcPrice] = useState(null);
  const [rcAccess, setRcAccess] = useState(false);
  const [history, setHistory] = useState([]);
  const [allHistory, setAllHistory] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [rcData, setRcData] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    fromDate: "",
    toDate: "",
  });

  const [uploading, setUploading] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const fetchPriceData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/access-check `,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setRcAccess(response.data?.serviceAccess.includes("rc_mobile"));
      setRcPrice(response.data?.servicePrices?.rc_mobile);
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/get-document-records?service=rc-mobile`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const historyData = response.data.map((item) => ({
        date: new Date(item.createdAt).toLocaleString(),
        rcNo: item.idNumber,
        name: item.apiResponse?.name || "N/A",
        details: "RC Verification",
        status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
        error: item.status === "failed" ? "Verification failed" : "",
        createdAt: new Date(item.createdAt),
      }));

      setAllHistory(historyData);
      setFilteredHistory(historyData);
      setHistory(historyData); // Set all three states initially
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch history");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
    fetchPriceData();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters]);

  const proceedWithApiCall = async () => {
    if (!rcNo.trim()) {
      toast.error("Please enter RC number");
      return;
    }

    setIsLoading(true);
    setError("");
    setRcData(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/services/rc/rc-to-mobile`,
        {
          id_number: rcNo,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.success === false) {
        throw new Error(response.data.message || "Failed to fetch RC data");
      }

      setRcData(response.data.data);
      setShowCard(true);

      const newEntry = {
        date: new Date().toLocaleString(),
        rcNo: response.data.data.rc_number,
        status: "Success",
      };

      setAllHistory((prev) => [newEntry, ...prev]);
      setFilteredHistory((prev) => [newEntry, ...prev]);
      setHistory((prev) => [newEntry, ...prev]);

      toast.success("RC data fetched successfully");
    } catch (err) {
      console.error("Error fetching RC data:", err);

      let errorMessage = "Failed to fetch RC data. Please try again.";
      if (err.response) {
        if (err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        } else if (err.response.status === 401) {
          errorMessage = "Unauthorized - Please login again";
        } else if (err.response.status === 403) {
          errorMessage = "Forbidden - You don't have permission";
        } else if (err.response.status === 404) {
          errorMessage = "Service not found";
        } else if (err.response.status === 500) {
          errorMessage = "Server error - Please try again later";
        }
      } else if (err.request) {
        errorMessage = "Network error - Please check your connection";
      }

      toast.error(errorMessage);

      const newEntry = {
        date: new Date().toLocaleString(),
        rcNo,
        status: "Failed",
        error: errorMessage,
      };

      setAllHistory((prev) => [newEntry, ...prev]);
      setFilteredHistory((prev) => [newEntry, ...prev]);
      setHistory((prev) => [newEntry, ...prev]);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    applyFilters();
  }, [filters, allHistory]);

  const applyFilters = () => {
    let filteredData = [...allHistory];

    // Apply search filter
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      filteredData = filteredData.filter(
        (item) =>
          item.rcNo.toLowerCase().includes(searchTerm) ||
          (item.name && item.name.toLowerCase().includes(searchTerm))
      );
    }

    // Apply status filter
    if (filters.status) {
      filteredData = filteredData.filter(
        (item) => item.status.toLowerCase() === filters.status.toLowerCase()
      );
    }

    // Apply date range filter
    if (filters.fromDate || filters.toDate) {
      const fromDate = filters.fromDate ? new Date(filters.fromDate) : null;
      const toDate = filters.toDate ? new Date(filters.toDate) : null;

      // Set time components for proper date comparison
      if (fromDate) fromDate.setHours(0, 0, 0, 0);
      if (toDate) toDate.setHours(23, 59, 59, 999);

      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.createdAt);
        let matches = true;

        if (fromDate && itemDate < fromDate) matches = false;
        if (toDate && itemDate > toDate) matches = false;

        return matches;
      });
    }

    setFilteredHistory(filteredData);
    setCurrentPage(1); // Reset to first page when filters change
  };

  const handleSubmit = async () => {
    setError("");
    if (!rcNo) {
      return setError("Please enter RC Number !");
    }
    if (!rcAccess) {
      return setError("You dont have access to this service");
    }
    // Show confirmation modal
    setShowConfirmationModal(true);
  };

  const clearFilters = () => {
    setFilters({
      search: "",
      status: "",
      fromDate: "",
      toDate: "",
    });
    setFilteredHistory(allHistory);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
  const currentData = filteredHistory.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const visiblePages = useMemo(() => {
    const delta = 2; // how many pages around current
    const pages = [];
    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }
    return pages;
  }, [currentPage, totalPages]);
  return (
    <div className="py-4 w-full">
      <div className="bg-blue-100 p-2 mb-4">
        <h2 className="text-center text-xl font-semibold text-blue-700">
          RC to Mobile No.
        </h2>
      </div>

      <div className="py-4 space-y-4">
        <div className="flex flex-col  gap-4   ">
          <input
            type="text"
            placeholder="Enter RC No"
            value={rcNo}
            onChange={(e) => setRcNo(e.target.value.toUpperCase())}
            className="w-1/2 border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            maxLength={10}
          />

          <div className="flex justify-start mt-4">
            <button
              onClick={handleSubmit}
              disabled={isLoading || !rcNo}
              className={`bg-indigo-600 text-white py-2 px-6 rounded hover:bg-indigo-700 ${
                isLoading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? "Processing..." : "SUBMIT"}
            </button>
          </div>
        </div>
      </div>

      {/* Filter Section */}
      <div className="w-full">
        <div className="bg-white p-4 shadow-md rounded-lg mb-4">
          <h3 className="text-lg font-semibold mb-4">
            RC to Mobile Check Results
          </h3>
 
          <div className="bg-gray-50 p-4 rounded-lg mb-4">
            <h4 className="text-md font-medium mb-3">Filter Current Results</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-1">Search</label>
                <input
                  type="text"
                  placeholder="Search vehicle number"
                  value={filters.search}
                  onChange={(e) =>
                    setFilters({ ...filters, search: e.target.value })
                  }
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Status</label>
                <select
                  value={filters.status}
                  onChange={(e) =>
                    setFilters({ ...filters, status: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="">All Status</option>
                  <option value="Success">Success</option>
                  <option value="Failed">Failed</option>
                  <option value="pending">Pending</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  From Date
                </label>
                <input
                  type="date"
                  value={filters.fromDate}
                  onChange={(e) =>
                    setFilters({ ...filters, fromDate: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  To Date
                </label>
                <input
                  type="date"
                  value={filters.toDate}
                  onChange={(e) =>
                    setFilters({ ...filters, toDate: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2"
                />
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={clearFilters}
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
              >
                Clear
              </button>
              <button
                onClick={applyFilters}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Apply
              </button>
            </div>
          </div>

          {/* History Table */}

          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-4 py-2">Sl No</th>
                  <th className="px-4 py-2">Date & Time</th>
                  <th className="px-4 py-2">RC No</th>
                  <th className="px-4 py-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((item, idx) => (
                    <tr key={idx} className="border-t hover:bg-gray-50">
                      <td className="px-4 py-2">
                        {(currentPage - 1) * itemsPerPage + idx + 1}
                      </td>
                      <td className="px-4 py-2">{item.date}</td>
                      <td className="px-4 py-2 font-mono">{item.rcNo}</td>
                      {/* <td className="px-4 py-2">{item.name}</td> */}
                      <td className="px-4 py-2">
                        <span
                          className={`px-2 py-1 rounded text-white text-xs ${
                            item.status === "Success"
                              ? "bg-green-500"
                              : "bg-red-500"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      className="px-4 py-4 text-center text-gray-500"
                    >
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="flex flex-col md:flex-row items-center justify-between mt-4">
            <span className="text-sm text-gray-500">
              Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
              {Math.min(currentPage * itemsPerPage, filteredHistory.length)} of{" "}
              {filteredHistory.length} entries
            </span>

            <div className="flex gap-2 mt-2 md:mt-0">
              <button
                onClick={handlePrev}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded text-sm disabled:opacity-50"
              >
                Prev
              </button>

              {visiblePages[0] > 1 && <span className="px-2">...</span>}
              {visiblePages.map((p) => (
                <button
                  key={p}
                  onClick={() => setCurrentPage(p)}
                  className={`px-3 py-1 border rounded text-sm ${
                    currentPage === p ? "bg-blue-600 text-white" : ""
                  }`}
                >
                  {p}
                </button>
              ))}
              {visiblePages[visiblePages.length - 1] < totalPages && (
                <span className="px-2">...</span>
              )}

              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded text-sm disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      {showConfirmationModal && (
        <PortalModal>
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
              <h3 className="text-lg font-semibold mb-4">Confirm Payment</h3>
              <p className="mb-4">
                This RC to mobile no fetch will cost you{" "}
                <span className="text-red-600"> ₹{rcPrice} </span>. Do you want
                to proceed?
              </p>
              <div className="flex justify-end gap-4">
                <button
                  onClick={() => setShowConfirmationModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setShowConfirmationModal(false);
                    proceedWithApiCall();
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Confirm & Pay
                </button>
              </div>
            </div>
          </div>
        </PortalModal>
      )}
      {showCard && rcData && (
        <PortalModal>
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center ">
            <div className="bg-white items-center   justify-center rounded-lg shadow-lg p-8 m-4">
              <div className="">
                <p className="text-2xl font-normal">
                  RC No:{" "}
                  <span className="text-2xl font-semibold">
                    {" "}
                    {rcData.rc_number}{" "}
                  </span>
                </p>
                <p className="text-2xl font-normal">
                  Mobile:{" "}
                  <span className="text-2xl font-semibold">
                    {" "}
                    {rcData.mobile_number}
                  </span>
                </p>
              </div>

              <div className="mt-4 flex justify-between">
                <button
                  onClick={() => setShowCard(false)}
                  className="bg-gray-300 px-4 py-1 rounded hover:bg-gray-400"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </PortalModal>
      )}
    </div>
  );
}
